import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {Timing} from '@aboutyou/mlm';
import {useIsGuestUser} from '@aboutyou/user';
import React, {useRef} from 'react';
import styled from 'styled-components';
import {AuthenticatedView} from '../../features/Authentication/AuthenticatedView/AuthenticatedView';
import {WebCheckout, WebExpressCheckout} from './WebCheckout';
import {CheckoutAnimation} from './components/CheckoutAnimation/CheckoutAnimation';
import {CheckoutErrorView} from './components/CheckoutErrorView';
import {BnplSlotsProps} from './components/PaymentSlots/BnplSlots';
import {ProductDetailsSlotsProps} from './components/ProductDetailsSlots/ProductDetailsSlots';
import {ScayleCheckoutScript} from './components/ScayleLoadingScript';
import {SustainabilitySlotsProps} from './components/SustainabilityBadge/SustainabilitySlots';
import {useAppUrlParams} from './hooks/useAppUrlParams';

export const Checkout: React.FC<
  SustainabilitySlotsProps &
    Pick<BnplSlotsProps, 'BnplInfoLayoutComponent'> &
    ProductDetailsSlotsProps
> = ({
  SustainabilityInfoLayoutComponent,
  BnplInfoLayoutComponent,
  ProductDetailsLayoutComponent,
}) => {
  const timing = useRef(new Timing()).current; // time measuring starts

  const isGuestUser = useIsGuestUser();
  const {transactionId} = useAppUrlParams();

  const {isActive: isGuestCheckoutAllowed} = useIsFeatureActive(
    'enable_guest_checkout',
  );

  if (transactionId) {
    return (
      <PageWrapper id="checkout-wrapper">
        <ScayleCheckoutScript />
        <WebExpressCheckout timing={timing} />
      </PageWrapper>
    );
  }

  if (isGuestUser) {
    return (
      <PageWrapper id="checkout-wrapper">
        <ScayleCheckoutScript />
        <WebCheckout
          timing={timing}
          SustainabilityInfoLayoutComponent={SustainabilityInfoLayoutComponent}
          BnplInfoLayoutComponent={BnplInfoLayoutComponent}
          ProductDetailsLayoutComponent={ProductDetailsLayoutComponent}
        />
      </PageWrapper>
    );
  }

  return (
    <PageWrapper id="checkout-wrapper">
      <ScayleCheckoutScript />
      <AuthenticatedView
        context="checkout-page"
        View={WebCheckout}
        Fallback={CheckoutErrorView}
        Loading={CheckoutAnimation.Show}
        allowGuestLogin={isGuestCheckoutAllowed}
        viewProps={{
          timing,
          SustainabilityInfoLayoutComponent,
          BnplInfoLayoutComponent,
          ProductDetailsLayoutComponent,
        }}
      />
    </PageWrapper>
  );
};

const PageWrapper = styled.div`
  position: relative;
  min-height: 105vh;
`;
